export default "__VITE_ASSET__CnuuHMUO__"